export default function buildCookieDomainAttributeValue() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'miro.com';
  var hostParts = host.split('.');
  var secondLevelDomain = hostParts.slice(-2).join('.');

  if (secondLevelDomain === 'testmiro.com') {
    return hostParts.slice(-3).join('.');
  }

  if (secondLevelDomain === 'miro-stg.net') {
    return secondLevelDomain;
  }

  if (secondLevelDomain !== 'miro.com') {
    // eslint-disable-next-line no-console
    console.warn("Request received from unknown domain: ".concat(host));
  }

  return 'miro.com';
}